<template>
  <div class="coachBox" v-if="rawData || errorMsg" @click="clickAll">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/coachIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">汽车票</div>
        </div>
        <!-- 柳州 -->
        <div
          class="infoBox"
          v-if="channel == 'dxlc'"
          :class="{ isExpire: isExpire }"
        >
          <div class="item">
            <span class="label">时间</span>
            <span class="text">{{ bizReq.schDate }}</span>
          </div>
          <div class="item">
            <span class="label">地点</span>
            <span class="text"
              >{{ bizReq.saleName }}-{{ bizReq.destStation }}</span
            >
          </div>
        </div>
        <!-- 南通 -->
        <div
          class="infoBox"
          v-if="channel == 'cxnt'"
          :class="{ isExpire: isExpire }"
        >
          <div class="item">
            <span class="label">时间</span>
            <span class="text">{{ bizReq.scheduleDate }}</span>
          </div>
          <div class="item">
            <span class="label">地点</span>
            <span class="text"
              >{{ bizReq.departStationName }}-{{
                bizReq.arriveStationName
              }}</span
            >
          </div>
        </div>
        <div class="list" v-if="rawData" :class="{ isExpire: isExpire }">
          <div
            class="listItem"
            v-for="(value, key) in rawData.list.slice(0, 4)"
            :key="key"
            @click="clickSch(value)"
          >
            <div class="left" v-if="value.scheduleMode == '非定时班'">
              <div class="p1">请在</div>
              <div class="p2">{{ value.scheduleTime }}</div>
              <div class="p1">前乘车</div>
            </div>
            <div class="left" v-else>
              <div class="p2">{{ value.scheduleTime }}</div>
              <div class="p1">约{{value.duration}}小时</div>
            </div>

            <div class="right">
              <div class="line1">
                <div class="leftSymbolBox">
                  <div class="point"></div>
                  <div class="line"></div>
                  <div class="point"></div>
                </div>
                <div class="rightStationInfoBox">
                  <div class="stationItem">{{ value.departStationName }}</div>
                  <div class="stationItem">{{ value.arriveStationName }}</div>
                </div>
                <div class="rightPriceBox">
                  <div class="priceBox">
                    <span class="priceSymbol">¥ </span>
                    <span class="priceText">{{ value.fullPrice }}</span>
                  </div>
                  <div class="ticketNum">剩{{ value.remainSeatNum }}张</div>
                </div>
              </div>
              <div class="line2">
                <span class="span">{{ value.vehicleLevel }}</span>
                <span class="span">·</span>
                <span class="span">班次号 {{ value.scheduleCode }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 暂无班次 -->
        <div
          :class="{ isExpire: isExpire }"
          class="noDataBox"
          v-if="rawData && rawData.list.length == 0 && errorMsg == ''"
        >
          <div class="topLine"></div>
          <img
            class="noDataIcon"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/noSchDataIcon.png"
            alt=""
          />
          <div class="text">暂无班次</div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          @click="clickMoreBtn"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/glx/",
    prod: "https://h5-lzgj.brightcns.com/glx/",
  },
  cxnt: {
    test: "https://h5-ntgj.test.brightcns.cn/coach/",
    prod: "https://h5-maas.speedits.com/coach/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  data: function () {
    return {
      isExpire: false,
      timer: null,
      channel: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
    };
  },
  props: ["businessContent"],
  mounted: function () {
    console.log(this.businessContent);
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
      this.bizReq = JSON.parse(this.businessContent.bizReq);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
    console.log(this.rawData);
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToCoachH5(-1);
        }, 1000);
      }
    },
    // 点击某个班次
    clickSch: function (value) {
      if (this.isExpire) {
        return;
      }
      this.jumpToCoachH5(2, value);
    },
    // 点击查看更多
    clickMoreBtn: function () {
      if (this.isExpire) {
        return;
      }
      // 如果有错误信息 跳到汽车票首页
      if (this.errorMsg != "") {
        this.jumpToCoachH5(-1);
      }
      // 跳到班次列表
      else {
        this.jumpToCoachH5(1);
      }
    },
    // 跳到汽车票h5 type  -1=>跳到汽车票首页 1=>跳到班次列表  2=>跳到详情
    jumpToCoachH5: function (type, value) {
      let url = config[this.businessContent.channel][env];

      // 判断是道行龙城还是畅行南通
      if (this.businessContent.channel == "dxlc") {
        if (type == -1) {
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
        }
        // 跳到班次列表
        if (type == 1) {
          let bizReq = JSON.parse(this.businessContent.bizReq);
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&startAreaName=${bizReq.saleName}&stopAreaName=${
              bizReq.destStation
            }&schDate=${bizReq.schDate}`;
        }
        // 先跳到班次列表  再跳到详情
        else if (type == 2) {
          let bizReq = JSON.parse(this.businessContent.bizReq);
          // 把3个值传给h5
          let { arriveStationName, departStationName, scheduleCode } = value;
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&startAreaName=${bizReq.saleName}&stopAreaName=${
              bizReq.destStation
            }&schDate=${
              bizReq.schDate
            }&arriveStationName=${arriveStationName}&departStationName=${departStationName}&scheduleCode=${scheduleCode}`;
        }
      } else if (this.businessContent.channel == "cxnt") {
        if (type == -1) {
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
        }
        // 跳到班次列表
        if (type == 1) {
          let bizReq = JSON.parse(this.businessContent.bizReq);
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&startAreaName=${bizReq.departStationName}&stopAreaName=${
              bizReq.arriveStationName
            }&schDate=${bizReq.scheduleDate}`;
        }
        // 先跳到班次列表  再跳到详情
        else if (type == 2) {
          // 把3个值传给h5
          let bizReq = JSON.parse(this.businessContent.bizReq);
          let { arriveStationName, departStationName, scheduleCode } = value;
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&startAreaName=${bizReq.departStationName}&stopAreaName=${
              bizReq.arriveStationName
            }&schDate=${
              bizReq.scheduleDate
            }&arriveStationName=${arriveStationName}&departStationName=${departStationName}&scheduleCode=${scheduleCode}`;
        }
      }
      console.log(url);
      window.location.href = url;
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./coachBox.scss";
</style>
